import React from 'react';
import { PageHeader } from '@/components/common/PageHeader';
import { Card, CardContent } from '@/components/ui/card';
import { CheckCircle2, Users, BookOpen, Award, Target, TrendingUp, Heart, Shield, Zap, Clock } from 'lucide-react';
import { motion } from 'framer-motion';

const WhyChooseUsPage = () => {
  const reasons = [
    {
      icon: Users,
      title: 'Expert Faculty',
      description: '45+ highly qualified and experienced teachers with proven track records in competitive exam coaching'
    },
    {
      icon: Award,
      title: 'Proven Results',
      description: '89% selection rate with 342+ JEE Advanced and 486+ NEET qualifiers in 2023'
    },
    {
      icon: BookOpen,
      title: 'Comprehensive Study Material',
      description: 'Well-researched content covering entire syllabus with practice questions and previous year papers'
    },
    {
      icon: Target,
      title: 'Personalized Attention',
      description: 'Small batch sizes of 30 students ensuring individual focus and doubt clearing'
    },
    {
      icon: TrendingUp,
      title: 'Regular Assessments',
      description: 'Weekly chapter tests, monthly comprehensive tests, and All India Test Series'
    },
    {
      icon: Shield,
      title: 'Trusted Brand',
      description: '15+ years of excellence in coaching with thousands of successful students'
    },
    {
      icon: Zap,
      title: 'Modern Infrastructure',
      description: 'Air-conditioned classrooms, well-equipped labs, library, and digital learning resources'
    },
    {
      icon: Clock,
      title: 'Flexible Batches',
      description: 'Multiple batch timings and weekend batches available for student convenience'
    },
    {
      icon: Heart,
      title: 'Student Welfare',
      description: 'Counseling support, parent-teacher meetings, and hostel facilities for outstation students'
    }
  ];

  return (
    <div>
      <PageHeader
        title="Why Choose Mantra Prayas"
        subtitle="Discover what makes us the preferred choice for competitive exam preparation"
        breadcrumbs={[
          { label: 'Home', path: '/' },
          { label: 'Why Choose Us' }
        ]}
      />

      <section className="section-padding bg-background">
        <div className="container-custom">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {reasons.map((reason, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
              >
                <Card className="h-full border-2 hover:border-primary transition-all duration-300 hover:shadow-lg group">
                  <CardContent className="p-8">
                    <div className="h-16 w-16 rounded-xl bg-primary/10 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                      <reason.icon className="h-8 w-8 text-primary" />
                    </div>
                    <h3 className="text-xl font-heading font-bold text-foreground mb-3">
                      {reason.title}
                    </h3>
                    <p className="text-muted-foreground leading-relaxed">
                      {reason.description}
                    </p>
                  </CardContent>
                </Card>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default WhyChooseUsPage;
